/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks'
import RankingInforContainer from './styled'
import { AVATAR_DEFAULT } from 'assets/images'
import { shortenRaceNameV2 } from 'utils/helper'
import RankCount from '../RankCount'
import { updateStateModal } from 'features/Profile/profile.slice'

const RankInfo = ({ data }: any) => {
  const profile: any = useAppSelector(state => state.profile)
  const dispatch = useAppDispatch()
  if (!profile?.public_address) {
    return null
  }

  const showModalInfo = (user_id: number) => () => {
    dispatch(updateStateModal({
      isOpen: true,
      userId: user_id
    }))
  }

  return (
    <RankingInforContainer>
      <div className='d-flex'>
        <div className='width-20 center'>
          <RankCount rank={data?.rank_index} />
        </div>
        <div className='width-20'>
          <div className='name'>
            <div className='img'>
              <img
                width={38}
                height={38}
                style={{ borderRadius: '100%', objectFit: 'cover' }}
                src={(data?.avatar ?? profile?.avatar) || AVATAR_DEFAULT}
                alt='avatar'
              />
            </div>
            <span onClick={showModalInfo(data?.user_id)}>{shortenRaceNameV2(data?.user_name ?? profile?.name, 14)}</span>
          </div>
        </div>
        <div className='width-10 left'>
          <span>{data?.item_donate ?? 0}</span>
        </div>
        <div className='width-10 left'>
          <span>{data?.ticket_donate ?? 0}</span>
        </div>
        <div className='width-10 left'>
          <span>{data?.adil_donate ?? 0}</span>
        </div>
        <div className='width-10 left'>
          <span>{data?.kuda_donate ?? 0}</span>
        </div>
        <div className='width-10 left'>
          <span>{data?.merah_donate ?? 0}</span>
        </div>
        <div className='width-10 left'>
          <span>{data?.booster_donate ?? 0}</span>
        </div>
      </div>
    </RankingInforContainer>
  )
}

export default memo(RankInfo)
